import {Form, Input} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import TranslationInput from "../../../../../shared/input/TranslationInput";
import Utils from "../../../../../../utils";
import IField from "../../../../../../model/interface/dataStorage/IField";

export interface IFieldBooleanOptions {
    trueLabel?: string,
    falseLabel?: string,
    nullLabel?: string
}

interface IProps extends IFieldOptionsEditorProps {
    field: IField
}

interface IState {
}

class FieldBooleanOptionsEditor extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {buildFieldName, field} = this.props
        return (
            <div>
                <Form.Item name={buildFieldName('trueLabel')} initialValue={'Povoleno'} label={'Název pro kladnou logickou hodnotu'}>
                    <TranslationInput code={'configuration.field.boolean.true-placeholder.' + field.uuid} customInput={(value, triggerSave, onChange) => {
                        return <Input prefix={<CheckOutlined/>}   onPressEnter={e => triggerSave(e.currentTarget.value)}
                               onBlur={e => triggerSave(e.currentTarget.value)}
                               onChange={e => onChange(e.target.value)}
                               value={value}/>
                    }}/>
                </Form.Item>
                <Form.Item name={buildFieldName('falseLabel')} initialValue={'Zakázano'} label={'Název pro zápornou logickou hodnotu'}>
                    <TranslationInput code={'configuration.field.boolean.false-placeholder.' + field.uuid} preserveCode={true} customInput={(value, triggerSave, onChange) => {
                        return <Input prefix={<CloseOutlined/>}   onPressEnter={e => triggerSave(e.currentTarget.value)}
                                      onBlur={e => triggerSave(e.currentTarget.value)}
                                      onChange={e => onChange(e.target.value)}
                                      value={value}/>
                    }}/>
                </Form.Item>
                <Form.Item name={buildFieldName('nullLabel')} initialValue={'není vyplněno'}
                           label={'Název pro prázdnou logickou hodnotu'}>
                    <TranslationInput code={'configuration.field.boolean.null-placeholder.' + field.uuid} preserveCode={true} customInput={(value, triggerSave, onChange) => {
                        return <Input onPressEnter={e => triggerSave(e.currentTarget.value)}
                                      onBlur={e => triggerSave(e.currentTarget.value)}
                                      onChange={e => onChange(e.target.value)}
                                      value={value}/>
                    }}/>
                </Form.Item>
            </div>
        )
    }
}


export default FieldBooleanOptionsEditor